export default __webpack_public_path__ + "static/media/html5.9be87547.svg";